import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { User } from './user';
import { ProfileService } from './profile.service';
import { CITIES } from './../../constants/cities';

@Component({
    selector: 'profile',
    template: require('./profile.component.html'),
    providers: [ProfileService]
})

export class SuperUserProfileComponent implements OnInit {

    classTermsModal: any;

    userProfile: User;
    userProfileClean: User;
    classMapModal: any;
    editingProfile: boolean;
    changingPassword: boolean;
    changingEmail: boolean;
    changingEmailPassword: boolean;
    changingCategory: boolean;
    changingLanguage: boolean;
    changingSubrole: boolean;
    modalTitle: String;

    //Properties useds for change email
    //Verify password
    invalidUserPasswordToChangeEmail: boolean;
    userPasswordToChangeEmail: string;
    //Change email
    invalidLengthEmail: boolean;
    invalidChangeEmail: boolean;
    invalidExistsEmail: boolean;
    userEmailChange: string;

    //Properties useds for check user passwords validation
    wrongPassword: boolean;
    oldUserPassword: String;
    newUserPassword: String;
    emptyOldUserPassword: boolean;
    emptyOrShortNewUserPassword: boolean;

    //Properties useds for check user fields validation
    wrongName: boolean;
    wrongNif: boolean;
    wrongPhone: boolean;
    wrongCity: boolean;
    wrongAddress: boolean;
    wrongZip: boolean;
    userName: string;
    userNif: string;
    userPhone: string;
    userCity: string;
    userAddress: string;
    userZip: string;
    emailSend: boolean;

    categoryUpdatedV: number;

    userLanguage: string;

    constructor(private _profileService: ProfileService) {
        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
        this.classTermsModal = { 'model': true, 'show': false, 'hide': true };
        this.editingProfile = false;
        this.changingEmail = false;
        this.changingPassword = false;
        this.changingEmailPassword = false;
        this.changingCategory = false;
        this.changingLanguage = false;
        this.changingSubrole = false;
        this.invalidChangeEmail = false;
        this.invalidLengthEmail = false;
        this.invalidExistsEmail = false;
        this.wrongPassword = false;
        this.invalidUserPasswordToChangeEmail = false;
        this.wrongName = false;
        this.wrongNif = false;
        this.wrongPhone = false;
        this.wrongCity = false;
        this.wrongAddress = false;
        this.wrongZip = false;
        this.emptyOldUserPassword = false;
        this.emptyOrShortNewUserPassword = false;
        this.modalTitle = "";
        this.oldUserPassword = "";
        this.newUserPassword = "";
        this.userPasswordToChangeEmail = "";
        this.emailSend = false;
    }

    ngOnInit() {
        this._profileService.getProfile().then(profile => {
            this.userProfile = profile.row;
            this.userProfileClean = profile.row[0];
            var cities = CITIES.filter(city => city.id === profile.row[0].city_id);
            this.userProfile[0].city_name = cities[0].name;
            this.userProfileClean.city_name = cities[0].name;
        });

        this._profileService.getUserLanguage().then(lang => {
            if (lang == 1) {
                this.userLanguage = "CATALAN";
            } else if (lang == 2) {
                this.userLanguage = "SPANISH";
            }
        });
    }

    editProfile() {
        this.changingEmail = false;
        this.changingSubrole = false;
        this.editingProfile = true;
        this.changingCategory = false;
        this.changingLanguage = false;
        this.changingPassword = false;
        this.changingEmailPassword = false;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "EDIT_PROFILE";
    }

    changePassword() {
        this.changingEmail = false;
        this.changingSubrole = false;
        this.changingPassword = true;
        this.changingLanguage = false;
        this.editingProfile = false;
        this.changingEmailPassword = false;
        this.changingCategory = false;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_PASSWORD";
    }

    changeSubrole() {
        this.changingEmail = false;
        this.changingPassword = false;
        this.editingProfile = false;
        this.changingLanguage = false;
        this.changingEmailPassword = false;
        this.changingCategory = false;
        this.changingSubrole = true;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_SUBROLE";
    }

    changeEmailPassword() {
        this.changingEmail = false;
        this.changingPassword = false;
        this.editingProfile = false;
        this.changingEmailPassword = true;
        this.changingCategory = false;
        this.changingLanguage = false;
        this.classMapModal.show = true;
        this.changingSubrole = false;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_EMAIL";
    }

    changeEmail() {
        this.changingPassword = false;
        this.changingLanguage = false;
        this.editingProfile = false;
        this.changingSubrole = false;
        this.changingEmailPassword = false;
        this.changingEmail = true;
        this.changingCategory = false;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_EMAIL";
    }

    sendEmail() {
        this._profileService.sendEmail().then(result => {
            this.emailSend = true;
        });
    }

    close(savedUser: User) {
        this.editingProfile = false;
        this.changingPassword = false;
        this.changingEmailPassword = false;
        this.changingLanguage = false;
        this.changingCategory = false;
        this.changingSubrole = false;
        this.changingEmail = false;
        if (savedUser) { console.log("savedUser"); }
    }

    closeModal() {
        this.classMapModal.show = false;
        this.classMapModal.hide = true;
    }

    saveModel() {
        if (this.editingProfile) {
            this.checkUserFields();
            if (this.wrongName || this.wrongNif || this.wrongPhone || this.wrongCity || this.wrongAddress || this.wrongZip) {
                this.closeModal();
                this.editProfile();
            } else {
                var city = CITIES.filter(city => city.name.toLowerCase() === this.userProfileClean.city_name.toLowerCase());
                this._profileService.editProfileInfo(this.userProfileClean, city[0].id);
                this.editingProfile = false;
                this.closeModal();
            }
        } else if (this.changingCategory) {
            this._profileService.changeCategory(this.categoryUpdatedV).subscribe((result) => {
                console.log(result);
                if (result != -1) {
                    this.userProfileClean.subrole = result;
                    this.closeModal();
                } else {
                    this.closeModal();
                }
            }, () => { });
        } else if (this.changingLanguage) {            
            console.log(this.userLanguage);
            this._profileService.getUserLanguage().then(lang => {
                console.log(lang);
                if (lang == 1) {
                    var language: string = "CATALAN";
                } else if (lang == 2) {
                    var language: string = "SPANISH";
                }
                if (language != this.userLanguage) {
                    this._profileService.changeLanguage(this.userLanguage).subscribe(res => {
                        if (res.code = 1) {
                            this.closeModal();
                            if (this.userLanguage == "CATALAN") {
                                localStorage.setItem("language", "cat");
                            } else if (this.userLanguage == "SPANISH") {
                                localStorage.setItem("language", "esp");
                            }
                            location.reload();
                        }
                    });
                } else {
                    this.closeModal();
                }
            });
        } else if (this.changingPassword) {
            if (!this.oldUserPassword) {
                this.emptyOldUserPassword = true;
            } else {
                this.emptyOldUserPassword = false;
            }

            if (!this.newUserPassword || this.newUserPassword.length < 4) {
                this.emptyOrShortNewUserPassword = true;
            } else {
                this.emptyOrShortNewUserPassword = false;
            }

            if (this.emptyOldUserPassword || this.emptyOrShortNewUserPassword) {
                this.wrongPassword = false;
                this.closeModal();
                this.changePassword();
            } else {
                this._profileService.verifyPassword(this.oldUserPassword).then(result => {
                    if (result) {
                        this._profileService.changePassword(this.newUserPassword).then(result => {
                            this.wrongPassword = false;
                            this.closeModal();
                        });
                    } else {
                        this.closeModal();
                        this.wrongPassword = true;
                        this.changePassword();
                    }
                });
            }
        } else if (this.changingEmailPassword) {
            this._profileService.verifyPassword(this.userPasswordToChangeEmail).then(result => {
                if (result) {
                    this.invalidUserPasswordToChangeEmail = false;
                    this.closeModal();
                    this.changeEmail();
                } else {
                    this.closeModal();
                    this.invalidUserPasswordToChangeEmail = true;
                    this.changeEmailPassword();
                }
            });
        } else if (this.changingEmail) {
            if (this.userEmailChange.length == 0 || this.userEmailChange.length > 50) {
                this.invalidLengthEmail = true;
            } else {
                this.invalidLengthEmail = false;
                if (!this.validateEmail(this.userEmailChange)) {
                    this.invalidChangeEmail = true;
                } else {
                    this.invalidChangeEmail = false;
                }
            }

            if (this.invalidChangeEmail || this.invalidLengthEmail) {
                this.closeModal();
                this.changeEmail();
            } else {
                this._profileService.existsEmail(this.userEmailChange).then(res => {
                    if (!res) {
                        this._profileService.changeEmail(this.userEmailChange).then(result => {
                            if (result = "1") {
                                this.closeModal();
                                this.userProfile[0].email = this.userEmailChange;
                                this.userProfileClean.email_active = false;
                            } else {
                            }
                        });
                    }
                    else {
                        this.invalidExistsEmail = true;
                        this.closeModal();
                        this.changeEmail();
                    }
                });
            }
        }
    }

    checkUserFields() {
        this.checkName();
        this.checkNif();
        this.checkPhone();
        this.checkCity();
        this.checkAddress();
        this.checkZip();
    }

    checkName() {
        if (this.userName.length == 0 || this.userName.length < 2 || this.userName.length > 60) {
            this.wrongName = true;
        } else {
            this.wrongName = false;
        }
    }

    checkNif() {
        if (this.userNif.length == 0 || !this.validateNIF(this.userNif)) {
            this.wrongNif = true;
        } else {
            this.wrongNif = false;
        }
    }

    checkPhone() {
        if (this.userPhone.length == 0 || !this.validPhone(this.userPhone)) {
            this.wrongPhone = true;
        } else {
            this.wrongPhone = false;
        }
    }

    checkCity() {

        var cities = CITIES.filter(city => city.name.toLowerCase() == this.userCity.toLowerCase());

        if (cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {

            this.userCity = cities[0].name;
            this.userProfile[0].city_name = cities[0].name;
            this.wrongCity = false;

        } else {

            this.wrongCity = true;

        }

    }

    checkAddress() {

        if (this.userAddress.length < 5 || this.userAddress.length > 120) {

            this.wrongAddress = true;

        } else {

            this.wrongAddress = false;

        }

    }

    checkZip() {

        if (this.userZip.length == 0 || !this.validZip(this.userZip)) {

            this.wrongZip = true;

        } else {

            this.wrongZip = false;

        }

    }

    userNameFunction(event: any) {
        this.userName = event.value;
    }

    userNifFunction(event: any) {
        this.userNif = event.value;
    }

    userPhoneFunction(event: any) {

        this.userPhone = event.value;

    }

    userCityFunction(event: any) {

        this.userCity = event.value;

    }

    userAddressFunction(event: any) {

        this.userAddress = event.value;

    }

    userZipFunction(event: any) {

        this.userZip = event.value;

    }

    oldUserPasswordFunction(event: any) {

        this.oldUserPassword = event.value;

    }

    newUserPasswordFunction(event: any) {

        this.newUserPassword = event.value;

    }

    userPasswordToChangeEmailFunction(event: any) {

        this.userPasswordToChangeEmail = event.value;

    }

    userChangeEmailFunction(event: any) {

        this.userEmailChange = event.value;

    }

    private validateNIF(value: string) {

        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;

    }

    private validPhone(phone: string) {

        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;
        var re2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im;
        return re.test(phone) || re2.test(phone);

    }

    private validZip(zip: string) {

        var re = /^[\+]?[(]?[0-9]{5}$/im;
        return re.test(zip);

    }

    private validateEmail(email: string) {

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);

    }

    showTerms() {
        this.classTermsModal.show = true;
        this.classTermsModal.hide = false;
    }

    closeTermsModal() {
        this.classTermsModal.show = false;
        this.classTermsModal.hide = true;
    }

    getSubrole() {
        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 3) {
            return "PROFESIONAL";
        } else if (this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 4) {
            return "TRADITIONAL";
        } else if (this.userProfileClean.subrole == 8 || this.userProfileClean.subrole == 9) {
            return "STANDARD";
        } else {
            return "UNDEFINED";
        }
    }

    subroleUpdatedAnswer(event: any) {

        this.closeModal();
        if (event.value) {
            this._profileService.getProfile().then(profile => {
                this.userProfile = profile.row;
                this.userProfileClean = profile.row[0];
                var cities = CITIES.filter(city => city.id === profile.row[0].city_id);
                this.userProfile[0].city_name = cities[0].name;
                this.userProfileClean.city_name = cities[0].name;
            });
        }
    }

    getCategory() {
        if (this.userProfileClean.subrole == 1 || this.userProfileClean.subrole == 2 || this.userProfileClean.subrole == 8) {
            return "CATEGORY_1";
        } else if (this.userProfileClean.subrole == 3 || this.userProfileClean.subrole == 4 || this.userProfileClean.subrole == 9) {
            return "CATEGORY_2";
        }
    }

    changeCategory() {
        this.changingEmail = false;
        this.changingPassword = false;
        this.editingProfile = false;
        this.changingEmailPassword = false;
        this.changingSubrole = false;
        this.changingLanguage = false;
        this.changingCategory = true;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_CATEGORY";
    }

    categoryUpdated(event: any) {
        console.log("category " + event.value);
        this.categoryUpdatedV = event.value;
    }

    languageUpdatedFunction(event: any) {
        this.userLanguage = event.value;
    }

    changeLanguage() {
        this.changingEmail = false;
        this.changingPassword = false;
        this.editingProfile = false;
        this.changingEmailPassword = false;
        this.changingSubrole = false;
        this.changingCategory = false;
        this.changingLanguage = true;
        this.classMapModal.show = true;
        this.classMapModal.hide = false;
        this.modalTitle = "CHANGE_LANGUAGE";
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/profile/profile.component.ts
 **/